import { AlertColor } from '@mui/material';
import { t } from 'i18next';

interface AlertConfig {
  alertVariant: AlertColor;
  alertContent: string;
}

export const loginAlertsMap: Record<string, AlertConfig> = {
  password_expired: {
    alertVariant: 'error',
    alertContent: t('passwordExpired', { ns: 'login' }),
  },
  failed: {
    alertVariant: 'error',
    alertContent: t('notsuccessful', { ns: 'login' }),
  },
  logout: {
    alertVariant: 'info',
    alertContent: t('logout', { ns: 'login' }),
  },
  session_expired: {
    alertVariant: 'error',
    alertContent: t('expired', { ns: 'login' }),
  },
  account_expired: {
    alertVariant: 'error',
    alertContent: t('accountExpired', { ns: 'login' }),
  },
  locked: {
    alertVariant: 'error',
    alertContent: t('locked', { ns: 'login' }),
  },
  disabled: {
    alertVariant: 'error',
    alertContent: t('disabled', { ns: 'login' }),
  },
  password_changed: {
    alertVariant: 'success',
    alertContent: t('passwordChanged', { ns: 'login' }),
  },
};
